import React, { useContext } from "react";
import PriceDisplay from "./ProductPrice";
import { UserContext } from "../context/UserContext"; // Import UserContext
import isProductAvailable from "../functions/isProductAvailable";

const ListItem_Ribbon = ({ product, priceInfo, ribbonSettings = [] }) => {
  const { recentlyViewedProducts, recentlyPurchasedProducts } = useContext(UserContext); // Get data from context
  const { blockedStatus } = ribbonSettings;

  // Check if the product is in the recently viewed products list
  const isPreviouslyViewed = recentlyViewedProducts.some((viewedProduct) => viewedProduct.id === product.seller_product_id);

  // Check if the product is in the recently purchased products list
  const purchasedProduct = recentlyPurchasedProducts.find((purchasedProduct) => purchasedProduct.id === product.seller_product_id);
  const purchaseDate = purchasedProduct ? new Date(purchasedProduct.date.seconds * 1000).toLocaleDateString() : null;

  if (!isProductAvailable(product)) {
    if (!blockedStatus || !blockedStatus.includes("backOrdered")) {
      return (
        <div style={styles.ribbon.container}>
          <div style={{ ...styles.ribbon.ribbon, background: "#c3c3c3", color: "black" }}>Back Ordered</div>
        </div>
      );
    }
  }

  if (priceInfo && priceInfo?.priceType === "offer_price") {
    return (
      <div style={styles.ribbon.container}>
        {priceInfo && priceInfo?.priceType === "offer_price" && product?.listing_stock_amount !== 0 ? (
          <>
            <PriceDisplay priceInfo={priceInfo} priceTheme={"price_banner"} price_banner_settings={{ price_banner_fontSize: ".75rem" }} />
          </>
        ) : null}
      </div>
    );
  }

  if (purchaseDate && (!blockedStatus || !blockedStatus.includes("purchased"))) {
    const date = new Date(purchasedProduct.date.seconds * 1000);
    const month = date.toLocaleString("default", { month: "short" }); // Get short month name
    const year = date.getFullYear();
    let purchaseDateShow = `${month} ${year}`;
    return (
      <div style={styles.ribbon.container}>
        <div style={{ ...styles.ribbon.ribbon, background: "#757575", color: "white" }}>Purchased {purchaseDateShow}</div>
      </div>
    );
  }

  if (isPreviouslyViewed && (!blockedStatus || !blockedStatus.includes("previouslyViewed"))) {
    return (
      <div style={styles.ribbon.container}>
        {blockedStatus}
        <div style={{ ...styles.ribbon.ribbon, background: "#d9d9d9", color: "black" }}>Previously Viewed</div>
      </div>
    );
  }

  return null; // Render nothing if no condition is met
};

export default ListItem_Ribbon;

const styles = {
  ribbon: {
    container: {
      position: "absolute",
      left: 0,
      top: 0,
      zIndex: 1,
      borderRadius: "6px 0 0 0",
      color: "white",
      fontSize: ".65rem",
      fontWeight: 600,
      minWidth: "90%",
    },
    ribbon: {
      position: "relative",
      zIndex: 1,
      borderRadius: "6px 0 0 0",
      padding: "2px 14px 2px 6px",
      color: "white",
      fontSize: ".60rem",
      fontWeight: 600,
      clipPath: "polygon(0 0, 100% 0%, 92% 100%, 0% 100%)",
      width: "auto",
      textAlign: "center",
    },
  },
};
